namespace advisorop.services {
  `use strict`;

    export class MeetingHubService {

        // item and level from Household Summary Grid 
        selHDItem: any;
        selHDLevel: string = "";

        static $inject = [`$http`, `$q`];
        constructor(private $http: ng.IHttpService, private $q: ng.IQService) {
        }

        replaceSlashes(str: string): string {
            var ret: string = str;
            if (ret != null)
                ret = str.replace(/\/|\\/g, "-");
            return ret;
        }

        toISOStringDateOnly(dateTime: Date): string {
            var iso = dateTime.toISOString();
            iso = iso.substring(0, iso.indexOf("T"));
            return iso;
        }
        getAllMeeting(startDate: Date = undefined, endDate: Date = undefined): ng.IHttpPromise<Array<domains.IMeeting>> {
            if (startDate == undefined) {
                var now = new Date();
                startDate = new Date(now.getFullYear(), now.getMonth(), 1);
                endDate = new Date(startDate);
                endDate.setMonth(endDate.getMonth() + 1);
            }
            return this.$http.get(`/api/meetinghub/getallmeeting/${this.toISOStringDateOnly(startDate)}/${this.toISOStringDateOnly(endDate)}`)
        };

        reserveMeeting(): ng.IHttpPromise<domains.IMeeting> {
            return this.$http.get(`/api/meetinghub/reservemeeting/`);
        }
        scheduleMeetingLater(meeting: domains.IMeeting): ng.IHttpPromise<domains.IMeeting> {
            return this.$http.post(`/api/meetinghub/schedulelater/`, meeting);
        }
        createMeeting(meeting: domains.IMeeting): ng.IHttpPromise<domains.IMeeting> {
            return this.$http.post(`/api/meetinghub/createmeeting/`, meeting);
        }
        updateMeeting(meeting: domains.IMeeting): ng.IHttpPromise<domains.IMeeting> {
            return this.$http.post(`/api/meetinghub/updatemeeting/`, meeting);
        }
        deleteMeeting(meetingId: number): ng.IHttpPromise<domains.IMeeting> {
            return this.$http.get(`/api/meetinghub/deletemeeting/${meetingId}`);
        }
        addHouseholdReport(mettingGuid: string, meetingId: number, householdId: number, showClosedInactive: boolean, hideSleeves: boolean, preview: boolean): ng.IHttpPromise<domains.IMeeting> {
            return this.$http.get(`/api/meetinghub/addhouseholdreport/${mettingGuid}/${meetingId}/${householdId}/${showClosedInactive}/${hideSleeves}/${preview}`);
        }
        emailParticipant(participantId: number, meeting: domains.IMeeting): ng.IHttpPromise<any> {
            return this.$http.post(`api/meetinghub/emailparticipant/${participantId}`, meeting);
        }
        getHouseholds(): ng.IHttpPromise<Array<domains.IHousehold>> {
            return this.$http.get(`/api/meetinghub/gethouseholds`);
        };
        getHouseholdsByAdvisor(advisorId: number): ng.IHttpPromise<Array<domains.IHousehold>> {
            return this.$http.get(`/api/meetinghub/gethouseholdsbyadvisor/` + advisorId);
        };
        getInvestorsByAdvisor(advisorId: number): ng.IHttpPromise<Array<domains.IInvestor>> {
            return this.$http.get(`/api/meetinghub/getinvestorsbyadvisor/` + advisorId);
        };

        getAvailableSchedules(): ng.IHttpPromise<Array<domains.IMeetingAvailabilityScheduleInline>> {
            return this.$http.get(`/api/meetinghub/getavailableschedules/`);
        };

        createUpdateAvailableSchedules(schedules: Array<domains.IMeetingAvailabilityScheduleInline>): ng.IHttpPromise<Array<domains.IMeetingAvailabilityScheduleInline>> {
            return this.$http.post(`/api/meetinghub/createupdateavailableschedules/`, schedules);
        }

        deleteAvailableSchedules(scheduleIds: Array<number>): ng.IHttpPromise<Array<domains.IMeetingAvailabilityScheduleInline>> {
            return this.$http.post(`/api/meetinghub/deleteavailableschedules/`, scheduleIds);
        }

        getResourceCalendars(): ng.IHttpPromise<Array<any>> {
            return this.$http.get(`/api/meetinghub/getresourcecalendars/`);
        };

        getCalendars(): ng.IPromise<any> {
            var def = this.$q.defer();

            this.$http.get(`/api/meetinghub/getcalendars/`).then(response => {
                return def.resolve({
                    success: true,
                    data: response.data
                })
            }, error => {
                return def.resolve({
                    success: false,
                    data: error
                })
            });

            return <ng.IPromise<any>>def.promise;
        };

        createUpdateCalendars(calendars: Array<domains.IMeetingHubCalendar>): ng.IHttpPromise<Array<domains.IMeetingHubCalendar>> {
            return this.$http.post(`/api/meetinghub/createupdatecalendars/`, calendars);
        }

        deleteCalendars(calendarIds: Array<number>): ng.IHttpPromise<Array<domains.IMeetingHubCalendar>> {
            return this.$http.post(`/api/meetinghub/deletecalendars/`, calendarIds);
        }

        getUnscheduledMeeting(meetingGuid: string, participantGuid: string): ng.IHttpPromise<domains.IMeeting> {
            return this.$http.get(`/api/meetinghub/unscheduledmeeting/${meetingGuid}/${participantGuid}`);
        }

        getMeeting(meetingGuid: string, participantGuid: string): ng.IHttpPromise<domains.IMeeting> {
            var body = {
                meetingGuid: meetingGuid, participantGuid: participantGuid
            }
            return this.$http.post(`/api/meetinghub/meeting/`, body);
        }

        getDocuments(meetingGuid: string, participantGuid: string): ng.IHttpPromise<Array<domains.IDmsDocument>> {
            var body = {
                meetingGuid: meetingGuid, participantGuid: participantGuid
            }
            return this.$http.post(`/api/meetinghub/meeting/documents/`, body);
        }

        disableDocument(model: domains.IDmsDocument): ng.IHttpPromise<boolean> {
            return this.$http.get(`/api/meetinghub/disabledocument/${model.id}/${model.version}`);
        };

        logout(): ng.IHttpPromise<null> {
            return this.$http.get('/api/meetinghub/meeting/logout/');
        }

        ////////////////////////////////////////////////////
        ///////////////////////Meeting NOTES///////////////
        ///////////////////////////////////////////////////

        createNote(note: domains.INote, type: domains.NotesType): ng.IHttpPromise<domains.INote> {
            return this.$http.post(`/api/meetinghub/addnote`, note);
        };

        updateNote(note: domains.INote, type: domains.NotesType): ng.IHttpPromise<domains.INote> {
            return this.$http.post(`/api/meetinghub/updatenote/`, note);
        };

        deleteNote(model: domains.INote): ng.IHttpPromise<any> {
            return this.$http.post(`/api/meetinghub/deletenote`, model);
        };

        getNotes(meetingId: number, showDeleted: boolean, type: domains.NotesType): ng.IHttpPromise<Array<domains.INote>> {
            return this.$http.get(`/api/meetinghub/getnote/` + meetingId + "/" + showDeleted);
        };

        getNoteById(noteId: number): ng.IHttpPromise<domains.INote> {
            return this.$http.get(`/api/meetinghub/getnotebyid/` + noteId);
        };
    }
    angular.module(Constants.ADVOP_SERVICES).service(`meetingHubService`, MeetingHubService);
} 